import NODE_ENV from '../../RequestMgr/NodeEnvType'

const TOP_LEFT_CORNER = '┌'
const BOTTOM_LEFT_CORNER = '└'
const MIDDLE_CORNER = '├'
const HORIZONTAL_LINE = '│'
const DOUBLE_DIVIDER = '──────────────────────────────────────────────────────────────────────────────────────'
const SINGLE_DIVIDER = '┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄'


let isOpenLog = () => {
  return process.env.VUE_APP_NODE_ENV === NODE_ENV.DEV
}

export default {

  json(type, tag, content) {
    if (!content) {
      content = tag
      tag = ''
    }
    let arrs = Object.keys(content).length !== 0 ? formatJson(content) : ['{}']
    if (arrs && arrs.length > 0) {
      this.TOP_LEFT_CORNER(type, tag)
      arrs.forEach(item => {
        if (item !== '\r\n')
          this.common(type, '', HORIZONTAL_LINE + ' ' + item)
      })
      this.BOTTOM_LEFT_CORNER(type, tag)
    } else {
      this.common(type, tag, tag + content)
    }
  }
  ,
  TOP_LEFT_CORNER(type, tag) {
    let temp = DOUBLE_DIVIDER

    if (tag) {
      let min = DOUBLE_DIVIDER.slice(0, DOUBLE_DIVIDER.length / 2)
      temp = min + ' ' + tag + ' ' + min
    }
    this.common(type, '', TOP_LEFT_CORNER + temp)
  }
  ,

  MIDDLE_CORNER(type, tag) {
    this.common(type, tag, MIDDLE_CORNER + SINGLE_DIVIDER)
  }
  ,

  BOTTOM_LEFT_CORNER(type, tag) {
    let temp = DOUBLE_DIVIDER
    if (tag) {
      let min = DOUBLE_DIVIDER.slice(0, DOUBLE_DIVIDER.length / 2)
      temp = min + ' ' + tag + ' ' + min
    }
    this.common(type, '', BOTTOM_LEFT_CORNER + temp)
  }
  ,

  prettyLog(type, tag, content) {
    if (!content) {
      content = tag
      tag = ''
    }
    this.TOP_LEFT_CORNER(type, tag)
    this.common(type, ' ' + HORIZONTAL_LINE, content)
    this.BOTTOM_LEFT_CORNER(type, tag)
  }
  ,

  common(type, tag, content = null) {
    if (!isOpenLog()) return
    if (!content) {
      content = tag
      tag = ''
    }
    if (!type) type = 'info'
    console[type](tag, content)
  }
}

var formatJson = function (json, options) {
  var reg = null,
    formatted = json,
    pad = 0,
    PADDING = '   '
  options = options || {}
  options.newlineAfterColonIfBeforeBraceOrBracket = (options.newlineAfterColonIfBeforeBraceOrBracket === true)
  options.spaceAfterColon = (options.spaceAfterColon !== false)
  if (typeof json !== 'string') {
    json = JSON.stringify(json)
  } else {
    json = JSON.parse(json)
    json = JSON.stringify(json)
  }
  reg = /([\{\}])/g
  json = json.replace(reg, '\r\n$1\r\n')
  reg = /([\[\]])/g
  json = json.replace(reg, '\r\n$1\r\n')
  reg = /(\,)/g
  json = json.replace(reg, '$1\r\n')
  reg = /(\r\n\r\n)/g
  json = json.replace(reg, '\r\n')
  reg = /\r\n\,/g
  json = json.replace(reg, ',')
  if (!options.newlineAfterColonIfBeforeBraceOrBracket) {
    reg = /\:\r\n\{/g
    json = json.replace(reg, ':{')
    reg = /\:\r\n\[/g
    json = json.replace(reg, ':[')
  }
  if (options.spaceAfterColon) {
    reg = /\:/g
    json = json.replace(reg, ':')
  }
  let arrs = [];
  (json.split('\r\n')).forEach(function (node, index) {
      var i = 0,
        indent = 0,
        padding = ''

      if (node.match(/\{$/) || node.match(/\[$/)) {
        indent = 1
      } else if (node.match(/\}/) || node.match(/\]/)) {
        if (pad !== 0) {
          pad -= 1
        }
      } else {
        indent = 0
      }
      for (i = 0; i < pad; i++) {
        padding += PADDING
      }
      arrs.push(padding + node + '\r\n')
      // formatted += padding + node + '\r\n'
      pad += indent
    }
  )
  return arrs
}
